import { FeatureType } from '@/types/FeatureType';
import { MapLayer } from '@/types/MapLayer';

export const MAP_LAYER_MAPPING = {
  [MapLayer.PARKING_FACILITY]: {
    featureType: FeatureType.PARKING_FACILITY,
  },
  [MapLayer.PARK_AND_RIDE_FACILITY]: {
    featureType: FeatureType.PARK_AND_RIDE_FACILITY,
  },
  [MapLayer.PICKUP_PARKING_FACILITY]: {
    featureType: FeatureType.PICKUP_PARKING_FACILITY,
  },

  [MapLayer.BUS_STATION]: {
    featureType: FeatureType.STATION,
  },
  [MapLayer.TRAIN_STATION]: {
    featureType: FeatureType.STATION,
  },
};
